<template>
  <section>
    <!--工具条-->
     <!--<el-col :span="4" class="toolbar">
      <el-button type="primary" size="small" @click="addHandler">新增</el-button>
    </el-col>-->
  
    <el-col :span="6" class="toolbar rightsearch">
      <el-input placeholder="搜索" size="small" v-model="query" @change="search">
        <el-button slot="append" icon="search" @click="search"></el-button>
      </el-input>
    </el-col>
    <el-table :data="tableData" border v-loading="listLoading">
      <el-table-column label="ID" prop="id" align="center">
      </el-table-column>
      <el-table-column label="快递模板" prop="name" align="center">
      </el-table-column>
      <el-table-column label="省份" prop="sheng" align="center">
      </el-table-column>
      <el-table-column label="首重" prop="shou_zhong" align="center">
      </el-table-column>
      <el-table-column label="首重价格" prop="shouzhong_price" align="center">
      </el-table-column>
      <el-table-column label="续重价格" prop="xuzhong_price" align="center">
      </el-table-column>
      <el-table-column label="操作" prop="labels" align="center">
        <template scope="scope">
          <el-button :plain="true" size="small" type="info"  @click="editHandler(scope.row)">修改</el-button>
          <el-button :plain="true" size="small" type="danger"  @click="deleteHandler(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-col :span="0" class="toolbar_page">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 15, 20, 30]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next"
        :total="total">
      </el-pagination>
    </el-col>

    <!--新增界面-->
    <el-dialog title="新增" v-model="addFormVisible">
      <el-form :model="addForm" label-width="150px" :rules="formRules" ref="addForm">
        <el-form-item label="快递模板" prop="moban_id">
          <el-select v-model="mobanId" filterable placeholder="请选择" size="small" style="width: 100%;">
            <el-option
              v-for="item in moban"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
         <el-form-item label="省份" prop="sheng">
          <el-select v-model="addForm.sheng"  placeholder="请选择">
            <el-option
              v-for="(item, index) in shengFen"
              :key="index"
              :label="item"
              :value="item"
              size="small">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="首重" prop="shou_zhong">
          <el-input v-model="addForm.shou_zhong" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="首重价格" prop="shouzhong_price">
          <el-input v-model="addForm.shouzhong_price" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="续重价格" prop="xuzhong_price">
          <el-input v-model="addForm.xuzhong_price" auto-complete="off" size="small" required></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="addSubmit" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--编辑界面-->
    <el-dialog title="编辑" v-model="editFormVisible">
      <el-form :model="editForm" label-width="150px" :rules="formRules" ref="editForm">
        <el-form-item label="快递模板" prop="moban_id">
          <el-select v-model="editForm.moban_id" filterable placeholder="请选择" size="small" style="width: 100%;">
            <el-option
              v-for="item in moban"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
            <el-form-item label="省份" prop="sheng">
          <el-select v-model="editForm.sheng"  placeholder="请选择">
            <el-option
              v-for="(item, index) in shengFen"
              :key="index"
              :label="item"
              :value="item"
              size="small">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="首重" prop="shou_zhong">
          <el-input v-model="editForm.shou_zhong" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="首重价格" prop="shouzhong_price">
          <el-input v-model="editForm.shouzhong_price" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="续重价格" prop="xuzhong_price">
          <el-input v-model="editForm.xuzhong_price" auto-complete="off" size="small" required></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="editSubmit" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
  import config from '../../config';
  import basicdata from '../../static/config/basicdata.js'

  export default {
    data() {
      return {
        tableData: [],
        total: 0,
        page: 1,
        pageSize: 15,
        listLoading: false,
        query: '',
        submitLoading: false,
        addFormVisible: false,
        addForm: {
          moban_id: '',
          sheng: '',
          shou_zhong: 0,
          shouzhong_price: 0,
          xuzhong_price: 0,
          admin_id: 0,
          status: 0
        },
        shengFen: basicdata.shengFen,
        editFormVisible: false,
        editForm: {},
        formRules: {},
        moban: [],
        mobanId: 0,
      }
    },
    methods: {
      //分页方法
      handleSizeChange(size) {
        this.pageSize = size;
        this.search();
      },
      handleCurrentChange(page) {
        this.page = page;
        this.search();
      },
      search() {
        this.getSearch(this.query);
      },
      getSearch(query) {
        this.listLoading = true;
        this.$axios.post(config.api_url + '/kuaidi/rule/page', {
          "page": this.page,
          "size": this.pageSize,
          "query": query
        }).then(response => {
          let data = response.data;
          if (data.state) {
            this.total = data.count;
            this.tableData = data.msg;
            this.listLoading = false;
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '获取数据异常，请联系管理员',
            type: 'error'
          });
        })
      },
      addSubmit() {
        this.$refs.addForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.submitLoading = true;
              let para = Object.assign({}, this.addForm);
              para.moban_id = parseInt(this.mobanId);
              para.shou_zhong = parseInt(para.shou_zhong);
              para.shouzhong_price = parseInt(para.shouzhong_price);
              para.xuzhong_price = parseInt(para.xuzhong_price);
              para.sheng =this.addForm.sheng;
              //异步请求
              this.$axios.post(config.api_url + '/kuaidi/rule',
                para).then(response => {
                if (response.data.state) {
                  this.$message({
                    message: '提交成功',
                    type: 'success'
                  });
                  this.$refs['addForm'].resetFields();
                  this.addFormVisible = false;
                  this.search();
                } else {
                  this.$message({
                    message: '提交失败，请联系管理员',
                    type: 'error'
                  });
                }
              }).catch(error => {
                console.log(error);
                this.$message({
                  message: '提交异常，请联系管理员',
                  type: 'error'
                });
              });
              this.submitLoading = false;
            });
          }
        });
      },
      //操作删除
      deleteHandler(id) {
        if (id != 0) {
          this.$confirm('是否删除?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$axios.delete(config.api_url + '/kuaidi/rule/' + id).then(response => {
              if (response.data.state) {
                this.$message({
                  message: '删除成功',
                  type: 'success'
                });
                this.search();
              } else {
                this.$message({
                  message: response.data.msg,
                  type: 'error'
                });
              }
            }).catch(error => {
              this.$message({
                message: '删除异常，请联系管理员',
                type: 'error'
              });
            });
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
        }
      },
      //修改数据弹框
      editHandler(row) {
        this.getKuaidiMoban();
        this.editFormVisible = true;
        this.editForm = row
      },
      editSubmit() {
        this.$refs.editForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.submitLoading = true;
              let para = Object.assign({}, this.editForm);
              para.moban_id = parseInt(para.moban_id);
              para.shou_zhong = parseInt(para.shou_zhong);
              para.shouzhong_price = parseInt(para.shouzhong_price);
              para.xuzhong_price = parseInt(para.xuzhong_price);
               para.sheng =this.editForm.sheng;
              //异步请求
              this.$axios.put(config.api_url + '/kuaidi/rule',
                para).then(response => {
                if (response.data.state) {
                  this.$message({
                    message: '提交成功',
                    type: 'success'
                  });
                  this.$refs['editForm'].resetFields();
                  this.editFormVisible = false;
                  this.search();
                } else {
                  this.$message({
                    message: '提交失败，请联系管理员',
                    type: 'error'
                  });
                }
              }).catch(error => {
                console.log(error);
                this.$message({
                  message: '提交异常，请联系管理员',
                  type: 'error'
                });
              });
              this.submitLoading = false;
            });
          }
        });
      },
      addHandler() {
        this.getKuaidiMoban();
        this.addFormVisible = true;
      },
      getKuaidiMoban() {
        this.$axios.get(config.api_url + '/kuaidi/moban'
        ).then(response => {
          if(response.data.state) {
            this.moban = [];
            let i = 0;
            for(const item of response.data.msg) {
              this.moban.push({
                label: item.name,
                value: item.id
              })
              if(i === 0)
               this.mobanId = item.id;
              i++;
            }
          } else {
            this.$message({
              message: '获取快递模板失败，请联系管理员',
              type: 'warning'
            });
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '获取快递模板异常，请联系管理员',
            type: 'error'
          });
        });
      }
    },
    created() {
      this.search();
    }
  }
</script>

<style scoped>
  .rightsearch {
    float: right;
  }
</style>



// WEBPACK FOOTER //
// rule.vue?28fd34bc